import { FaSeedling, FaBookOpen, FaPhotoVideo, FaYinYang } from 'react-icons/fa';

const features = [
    { 
        id: 1,
        icon: <FaSeedling />, // Seedling icon for Plant Diversity
        title: 'Zwiedzanie ogrodu',
        description: 'Przestrzeń, w której historia łączy się z naturą, a odpoczynek z edukacją i kulturą',
        link: '/Uslugi/1'
    },
    {
        id: 2,
        icon: <FaBookOpen />, // Tools icon for Design Consultation
        title: 'Oprowadzanie z przewodnikiem',
        description: 'Opowieści o historii dworum ciekawostki botaniczne i wiele innych',
        link: '/Uslugi/2'   
    },
    {
        id: 3,
        icon: <FaPhotoVideo />, // Paint roller icon for Custom Landscaping
        title: 'Sesje zdjęciowe',
        description: 'Zapewniamy piękne scenerie, naturalne światło i intymną atmosferę.',
        link: '/Uslugi/3'
    },
    {
        id: 4,
        icon: <FaYinYang />, // Recycling icon for Sustainable Practices
        title: 'Psychologia zieleni',
        description: 'Joga, ogrodoterapia, sesje terapeutyczne',
        link: '/Psychologia-zieleni/Sesje'
    },
];

export default features;